import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ErrorBoundary from "@/components/ErrorBoundary";

// Pages
import OrderLookup from "@/pages/OrderLookup";
import OrderDashboard from "@/pages/OrderDashboard";
import OrderDetails from "@/pages/OrderDetails";
import RequestType from "@/pages/RequestType";
import SelectExchange from "@/pages/SelectExchange";
import Summary from "@/pages/Summary";
import Confirmation from "@/pages/Confirmation";
import TrackRequest from "@/pages/TrackRequest";
import AdminLogin from "@/pages/admin/AdminLogin";

// Admin Pages (New Structure)
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminResiPage from "@/pages/admin/AdminResiPage";
import AdminAnalisiPage from "@/pages/admin/AdminAnalisiPage";
import AdminRequestDetail from "@/pages/admin/AdminRequestDetail";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import AdminEccezioniPage from "@/pages/admin/AdminEccezioniPage";
import AdminControlPanelPage from "@/pages/admin/AdminControlPanelPage";
import AdminEmailTemplatesPage from "@/pages/admin/AdminEmailTemplatesPage";
import AdminTestSimulatorPage from "@/pages/admin/AdminTestSimulatorPage";

// RMA Pages
import RMAStep1 from "@/pages/rma/RMAStep1";
import RMAStep2 from "@/pages/rma/RMAStep2";
import RMAStep3 from "@/pages/rma/RMAStep3";
import RMAConfirmation from "@/pages/rma/RMAConfirmation";

function App() {
  return (
    <ErrorBoundary>
      <div className="App min-h-screen">
        <BrowserRouter>
          <Routes>
            {/* Customer Flow */}
            <Route path="/" element={<OrderLookup />} />
            <Route path="/order/:orderNumber" element={<OrderDashboard />} />
            <Route path="/order/:orderNumber/select" element={<OrderDetails />} />
            <Route path="/order/:orderNumber/type" element={<RequestType />} />
            <Route path="/order/:orderNumber/exchange" element={<SelectExchange />} />
            <Route path="/order/:orderNumber/summary" element={<Summary />} />
            <Route path="/confirmation/:requestId" element={<Confirmation />} />
            <Route path="/track/:requestId" element={<TrackRequest />} />
            
            {/* RMA Flow */}
            <Route path="/order/:orderNumber/rma/step1" element={<RMAStep1 />} />
            <Route path="/order/:orderNumber/rma/step2" element={<RMAStep2 />} />
            <Route path="/order/:orderNumber/rma/step3" element={<RMAStep3 />} />
            <Route path="/rma/confirmation/:rmaId" element={<RMAConfirmation />} />
            
            {/* Admin Flow */}
            <Route path="/admindea26" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route path="/admindea26/dashboard" element={<AdminDashboardPage />} />
              <Route path="/admindea26/resi" element={<AdminResiPage />} />
              <Route path="/admindea26/resi/:requestId" element={<AdminRequestDetail />} />
              <Route path="/admindea26/eccezioni" element={<AdminEccezioniPage />} />
              <Route path="/admindea26/analisi" element={<AdminAnalisiPage />} />
              <Route path="/admindea26/pannello-controllo" element={<AdminControlPanelPage />} />
              <Route path="/admindea26/email-templates" element={<AdminEmailTemplatesPage />} />
              <Route path="/admindea26/simulatore" element={<AdminTestSimulatorPage />} />
              <Route path="/admindea26/impostazioni" element={<AdminSettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </div>
    </ErrorBoundary>
  );
}

export default App;
